// extracted by mini-css-extract-plugin
export default {"container":"BookingManagement_container__BDZbB","sectionTitle":"BookingManagement_sectionTitle__9+jpQ"};